<template>
  <span
    >[{{ new Date() }},
    <span v-if="showWlReady">wlReady: {{ whitelabelReady ? "y" : "n" }}, </span>loading:
    {{ $auth.loading ? "y" : "n" }}, status: {{ $auth.step || "no val" }}, auth:
    {{ $auth.isAuthenticated ? "y" : "n" }}, auth err: {{ $auth.error ? $auth.error : "none" }},
    err:
    {{ errorString ? errorString : "none" }}
    <span v-if="$auth.isAuthenticated"
      >, user: {{ $auth.user.sub }}, email:
      {{
        userProfile && userProfile.businessEmail
          ? userProfile.businessEmail
          : userProfile && userProfile.businessPhone
          ? userProfile.businessPhone
          : "none"
      }}, token: {{ token ? token.length : "n" }}, perm:
      {{ permissions ? permissions.length : "n" }}, fail: {{ failedLogin ? "y" : "n" }}</span
    ><span v-if="tierFail"
      >, tier-fail: wl={{ failedWhitelabel ? "y" : "n" }}, perms={{
        failedPermissions ? "y" : "n"
      }}, bl={{ blacklisted ? "y" : "n" }}</span
    >]</span
  >
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    showWlReady: { type: Boolean, default: false },
    tierFail: { type: Boolean, default: false },
    blacklisted: { type: Boolean, default: false },
  },
  computed: {
    ...mapState([
      "errorString",
      "userProfile",
      "token",
      "permissions",
      "failedLogin",
      "failedWhitelabel",
      "failedPermissions",
      "whitelabelReady",
    ]),
  },
};
</script>
